export const authenticationInitialState = {
    status: 'loading',
    user: undefined,
    workspace: undefined,
};
export const authenticationReducer = (state, action) => {
    switch (action.type) {
        case 'SIGN_IN': {
            const { user } = action;
            return {
                ...state,
                user: user,
                status: 'authenticated',
            };
        }
        case 'SET_WORKSPACE': {
            const { workspace } = action;
            return {
                ...state,
                workspace,
            };
        }
        case 'UPDATE_USER': {
            const { user } = action;
            return {
                ...state,
                user,
            };
        }
        case 'SIGN_OUT':
            return {
                ...state,
                user: undefined,
                workspace: undefined,
                status: 'unauthenticated',
            };
    }
};
